import React from 'react';
import ReactDOM from 'react-dom';
import { AppContextProvider } from '../../../../Services/AppContext';
import { loadDOMComponent } from '../../../../helpers';
import SearchWorkplaceOld from './SearchWokrplaceOld';
import {store} from "../../../../store/store";
import {Provider} from "react-redux";

loadDOMComponent({
	selector: 'react-search-workplace',
	callback: ({ container, context, props }: any) => {
		const linkSelect = container.getAttribute('linkSelect') || null;
		const gqlParams = JSON.parse(container.getAttribute('gqlParams') || '{}');

		// selectLink
		ReactDOM.render(
			<Provider store={store}>
				<AppContextProvider {...context}>
					<SearchWorkplaceOld linkSelect={linkSelect} gqlParams={gqlParams} />
				</AppContextProvider>
			</Provider>,
			container,
		);
	},
});
